import { PerformanceAudienceChartMetric } from '@/services/endpoints/performanceAudience';

export const CHART_METRICS: PerformanceAudienceChartMetric[] = ['impressions', 'clicks', 'cost', 'ctr'];

export const PLATFORM_CHART_COLORS = {
  google: 'var(--brand-600)',
  meta: 'var(--brand-600)',
} as const;
